<template>
  <div>
    <div class="d-flex justify-content-end mb-1">
      <b-button
        variant="primary"
        @click="$router.push('/leads/add-lead')"
      >
        <feather-icon icon="PlusIcon" />
        {{ t('Add Lead') }}
      </b-button>
    </div>
    <Statistics :count-data="countData" />
    <TodaysReminder/>
    <FunnelReport :industries="industries" :parentService="parentService" :states="states"/>
    <PipeLineReport :industries="industries" :parentService="parentService" :states="states"/>
    <WeeklyReport :industries="industries" :parentService="parentService" :states="states"/>
    <QuickLinks />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils } from '@core/libs/i18n'
import Statistics from './Statistics.vue'
import PipeLineReport from './PipeLineReport.vue'
import WeeklyReport from './WeeklyReport.vue'
import QuickLinks from './QuickLinks.vue'
import store from '../../../store'
import constants from '@/constants'
import { hideLoader, showLoader } from '@/utils/common'
import FunnelReport from './FunnelReport.vue'
import TodaysReminder from './TodaysReminder.vue'

export default {
  components: {
    Statistics,
    BButton,
    QuickLinks,
    PipeLineReport,
    WeeklyReport,
    FunnelReport,
    TodaysReminder,
  },
  data() {
    return {
      TodayLeadCount: 0,
      TotalLeadCount: 0,
      searchParams: {},
      countData: [],
      LeadData: {},
      setInterval: '',
      industries: [],
      parentService: [],
      states: [],
    }
  },
  created() {
    this.GetCountSummary()
  },
  mounted() {
    store.dispatch('storeSetting/getParametersByParentId', { para_parent_id: constants.parentParameterIds.industryId })
      .then(response => {
        if (response.data.code === constants.SUCCESS) {
          this.industries = response.data.data
        }
      })
    store.dispatch('storeSetting/getParentService')
      .then(response => {
        if (response.data.code === constants.SUCCESS) {
          this.parentService = response.data.data
        }
      })
    store.dispatch('getCountryList/getStateList', { country_id: '' })
      .then(response => {
        if (response.data.code === constants.SUCCESS) {
          this.states = response.data.data
        }
      })
    this.setInterval = window.setInterval(() => {
      this.GetCountSummary()
    }, 60000)
  },
  destroyed() {
    window.clearInterval(this.setInterval)
  },
  setup() {
    const { t } = useUtils()
    return { t }
  },
  methods: {
    async GetCountSummary() {
      showLoader()
      await store.dispatch('DashboardApi/GetCountSummary', this.searchParams).then(async response => {
        if (response.data.code === constants.SUCCESS) {
          this.countData = response.data.data
        }
        hideLoader()
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Something went wrong',
            icon: 'Danger',
            variant: 'danger',
            text: '',
          },
        })
        hideLoader()
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
